import React from 'react';
import { Grid, TextField } from '@mui/material';
import { ISubscriptionData } from '../types';

interface ISubscriptionMiscellaneousProps {
  subscriptionData: ISubscriptionData;
  setSubscriptionData: React.Dispatch<React.SetStateAction<ISubscriptionData>>;
}

export const SubscriptionMiscellaneous: React.FC<ISubscriptionMiscellaneousProps> = ({
  subscriptionData,
  setSubscriptionData,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Quote ID"
          type="text"
          size="small"
          fullWidth
          sx={{ background: "white" }}
          value={subscriptionData.quoteId}
          onChange={(e) => {
            setSubscriptionData((old) => ({
              ...old,
              quoteId: e.target.value,
            }));
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="PO Number"
          type="text"
          size="small"
          fullWidth
          sx={{ background: "white" }}
          value={subscriptionData.poNumber ?? ''}
          onChange={(e) => {
            setSubscriptionData((old) => ({
              ...old,
              poNumber: e.target.value,
            }));
          }}
        />
      </Grid>
    </Grid>
  );
};
